const esDeviceTrust = {
  userDevices: 'Dispositivos',
  userDevicesTitle: 'Dispositivos de confianza',
  userDevicesHint: 'Revisa los equipos desde los que inicia sesión este usuario. Bloquea hardware desconocido o aprueba dispositivos nuevos.',
  userDevicesEmpty: 'Aún no hay dispositivos registrados.',
  userDeviceTrusted: 'De confianza',
  userDeviceUntrusted: 'Pendiente de revisión',
  userDeviceBlocked: 'Bloqueado',
  userDevicePasskey: 'Passkey',
  userDeviceLastSeen: 'Último acceso',
  userDeviceTrust: 'Confiar dispositivo',
  userDeviceBlock: 'Bloquear dispositivo',
  userDeviceUnblock: 'Desbloquear dispositivo',
  deviceBlockedLogin: 'Este dispositivo está bloqueado. Contacta a tu banquero.',
  devicePendingLogin: 'Este dispositivo aún no está aprobado. Pide a tu banquero que lo confíe en Usuarios → Dispositivos.',
  devicePasskeyLogin: 'Falló o se canceló la verificación passkey del dispositivo. Inténtalo de nuevo en este equipo.',
  deviceTrustMode: 'Política de dispositivos',
  deviceTrustModeDesc: 'Controla alertas y bloqueo de dispositivos nuevos para listeros y recogedores. En producción el valor por defecto es bloquear desconocidos.',
  deviceTrustModeOff: 'Desactivado',
  deviceTrustModeAlert: 'Solo alertar',
  deviceTrustModeEnforce: 'Bloquear desconocidos',
  passkeyLoginTitle: 'Passkey del dispositivo',
  passkeyLoginDesc: 'Registra una passkey WebAuthn en navegadores/dispositivos compatibles para entrar sin escribir la contraseña.',
  passkeyEnable: 'Registrar passkey',
  passkeyDisable: 'Borrar preferencia local de passkey',
  passkeyRegistered: 'Passkey registrada en este dispositivo.',
};

export default esDeviceTrust;
